import { SvgIconProps } from './icon-props';

export default function PlayButtonSmall({ height = 180, width = 180, className }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			className={className}
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 180 180"
		>
			<path d="M90 0a90 90 0 1 0 90 90A90 90 0 0 0 90 0zm0 171a81 81 0 1 1 81-81 81 81 0 0 1-81 81z" />
			<path d="M63 54v72l62.4-38.4z" />
		</svg>
	);
}
